export default "__VITE_ASSET__Cx0NUc80__"